import { useEffect, useRef } from 'react';
import { SKILLS } from '../data/portfolioData';

export const Skills = ({ isVisible }) => {
  const fieldRef = useRef(null);

  useEffect(() => {
    const field = fieldRef.current;
    if (!field) return;

    const placeOrbs = () => {
      field.innerHTML = '';
      const W = field.clientWidth;
      const H = 640;
      const placed = [];
      const isMobile = window.innerWidth < 900;

      SKILLS.forEach((skill) => {
        const size = isMobile
          ? Math.max(60, Math.min(104, skill.size * 0.65))
          : skill.size;
        let x = 0, y = 0, tries = 0;

        const overlaps = (px, py) =>
          placed.some((p) => {
            const dx = p.x + p.s / 2 - (px + size / 2);
            const dy = p.y + p.s / 2 - (py + size / 2);
            return dx * dx + dy * dy < Math.pow((p.s + size) / 2 + 8, 2);
          });

        do {
          x = Math.random() * (W - size);
          y = Math.random() * (H - size);
          tries++;
        } while (tries < 400 && overlaps(x, y));

        placed.push({ x, y, s: size });

        const el = document.createElement('div');
        el.className = `orb ${skill.color}`;
        el.style.cssText = [
          `width:${size}px`,
          `height:${size}px`,
          `left:${x}px`,
          `top:${y}px`,
          `font-size:${Math.max(11, size * 0.13)}px`,
          `--orb-dur:${4 + Math.random() * 4}s`,
          `--orb-delay:-${(Math.random() * 5).toFixed(2)}s`,
          `--orb-rot:${((Math.random() - 0.5) * 8).toFixed(1)}deg`,
        ].join(';');

        const badge = skill.badge
          ? `<br/><small style="font-family:VT323,monospace;font-size:.72em;letter-spacing:2px;opacity:.85">${skill.badge}</small>`
          : '';
        el.innerHTML = `<span>${skill.name}${badge}</span>`;
        field.appendChild(el);
      });
    };

    placeOrbs();

    const onResize = () => {
      clearTimeout(window.__orbTick);
      window.__orbTick = setTimeout(placeOrbs, 200);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const legend = [
    { cls: 'dot-pink',  label: 'languages' },
    { cls: 'dot-lilac', label: 'frameworks' },
    { cls: 'dot-mint',  label: 'tooling' },
    { cls: 'dot-lemon', label: 'practice' },
  ];

  return (
    <section id="skills" className={`skills ${isVisible ? 'fade-in' : ''}`}>
      <div className="sec-head">
        <span className="kicker">◆ 02 · LOADOUT</span>
        <h2>Skills in my <em>inventory</em></h2>
      </div>

      <div className="orb-field" ref={fieldRef} id="orbField" />

      <div className="skill-legend">
        {legend.map((l) => (
          <span key={l.label}>
            <b className={`dot ${l.cls}`} />
            {l.label}
          </span>
        ))}
      </div>
    </section>
  );
};
